import { Component } from '@angular/core';
import { FormControl } from '@angular/forms';
import { NavController, NavParams, ToastController, AlertController, LoadingController } from 'ionic-angular';

import { ParticipacaoProvider } from '../../providers/participacao/partipacao.provider';
import { AnonymizeProvider } from '../../providers/anonymize/anonymize.provider';
import { PermissionService } from '../../providers/permission-service';

import { Evento } from '../../domain/evento';
import { Participacao } from '../../domain/participacao';
import { ReciclagemPage } from '../reciclagem/reciclagem';
import { ContratoSearchPage } from '../contratos/contrato-search/contrato-search';
import { ContratoProvider } from '../../providers/contrato/contrato.provider';
import { ReciclagemHistoricoPage } from '../reciclagem/reciclagem-historico/reciclagem-historico';

//@IonicPage()
@Component({
  selector: 'page-participacao',
  templateUrl: 'participacao.html',
})
export class ParticipacaoPage {
  evento_aberto: Evento;
  participacoes: any;
  listaCompleta: Participacao[] = [];
  loadingLista: boolean = false;
  currentPage: number = 1;
  totalPages: number = 1;
  pageLimit: number = 20;

  searchTerm: string = '';
  searchControl: FormControl;
  searching: any = false;
  searchFocused: boolean = false;
  private searchTimeout: any;

  buttons:any;

  constructor(public navCtrl: NavController,
              public navParams: NavParams,
              public toastCtrl: ToastController,
              public loading: LoadingController,
              public alertCtrl: AlertController,
              public participacaoProvider: ParticipacaoProvider,
              public contratoProvider: ContratoProvider,
              public anonymizeProvider: AnonymizeProvider,
              private permissionService: PermissionService) {

      if(this.navParams.get('id') !== undefined && this.navParams.get('id') > 0){
        let load  = this.loading.create({content: 'Consultados dados...'});
        load.present();

        this.contratoProvider.getById(this.navParams.get('id'))
                             .subscribe(contrato => {
                                this.getEventoAberto();
                                load.dismiss();
                                this.adicionarParticipante(contrato);
                             });
      }

      this.searchControl = new FormControl();
      this.getEventoAberto();
      this.acoes();
  }

  ionViewDidLoad() {
    // Implementar controle de permissões - Ticket #5954
    this.checkPermissions();

    this.carregarLista();
  }

  /**
   * Verifica permissões do usuário para participação/reciclagem
   * Implementa mapeamento para aderência - Ticket #5954
   */
  private checkPermissions(): void {
    try {
      // Usar método de navegação que automaticamente mapeia 'participacao' -> 'reciclagem'
      const hasAccess = this.permissionService.hasNavigationPermission('participacao', 'index');
      const userProfile = this.permissionService.getCurrentUserProfile();
      
      const profileName = userProfile && userProfile.nome ? userProfile.nome : 'sem perfil';
      console.info('[PARTICIPACAO] Perfil:', profileName, ', Pode acessar:', hasAccess);
      
      // ADMINISTRADOR e OPERADOR sempre têm acesso no mobile
      if (userProfile && (userProfile.isAdmin || userProfile.isOperador)) {
        console.info('[PARTICIPACAO] Acesso concedido por perfil privilegiado:', profileName);
        return;
      }
      
      if (!hasAccess) {
        console.info('[PARTICIPACAO] Acesso negado para perfil:', profileName);
        this.permissionService.logPermissionCheck('participacao', 'index', false);
        
        let toast = this.toastCtrl.create({
          message: 'Você não tem permissão para acessar reciclagem',
          duration: 3000,
          position: 'top'
        });
        toast.present();
        
        // Voltar para página anterior ou home
        this.navCtrl.setRoot('HomePage');
        return;
      }
      
      console.info('[PARTICIPACAO] Acesso concedido para perfil:', profileName);
    } catch (error) {
      console.info('[PARTICIPACAO] Erro ao verificar permissões:', error, '- Permitindo acesso por segurança');
      // Em caso de erro, permitir acesso para não quebrar o app
    }
  }

  onSearchInput(){
    clearTimeout(this.searchTimeout);
    this.searchTimeout = setTimeout(() => this.searchByNUC(), 500);
  }
  /*
  setFilteredItems() {
    if(this.searchTerm != ''){
        let busca = this.participacaoProvider.searchInEvento(this.evento_aberto, this.searchTerm.toUpperCase());
        busca.subscribe(result => {
            this.participacoes = result as Participacao[];
            this.searching     = false;
        })
    }else{
        this.participacoes = false;
        this.searching     = false;
    }
  }
  */

  carregarLista(){
    if (!this.evento_aberto) return;
    this.loadingLista = true;
    this.currentPage = 1;
    this.listaCompleta = [];
    this.participacaoProvider.getByEventoPaginated(this.evento_aberto, 1, this.pageLimit).subscribe(
      result => {
        this.listaCompleta = result.data as Participacao[];
        this.totalPages = result.last_page || 1;
        this.loadingLista = false;
      },
      () => { this.loadingLista = false; }
    );
  }

  loadMore(infiniteScroll: any) {
    if (this.currentPage >= this.totalPages) {
      infiniteScroll.complete();
      return;
    }
    this.currentPage++;
    this.participacaoProvider.getByEventoPaginated(this.evento_aberto, this.currentPage, this.pageLimit).subscribe(
      result => {
        this.listaCompleta = this.listaCompleta.concat(result.data as Participacao[]);
        infiniteScroll.complete();
      },
      () => { infiniteScroll.complete(); }
    );
  }

  hasMorePages(): boolean {
    return this.currentPage < this.totalPages;
  }

  clearSearch() {
    this.searchTerm = '';
    this.participacoes = false;
  }

  searchByNUC(){
    if(this.searchTerm != ''){
      let busca = this.participacaoProvider.searchInEvento(this.evento_aberto, this.searchTerm.toUpperCase());
      busca.subscribe(result => {
          this.participacoes = result as Participacao[];
          this.searching     = false;
      })
    }else{
        this.participacoes = false;
        this.searching     = false;
    }
  }

  acoes() {
    this.buttons = [
      {nome:'Reciclar', icon:'git-compare', color:'avsi', action:'reciclar'},
      {nome:'Histórico', icon:'stats', color:'primary', action:'historico'},
      {nome:'Remover', icon:'close', color:'danger', action:'remover' }
    ];
  }

  buttonClicked(button:any, participante:Participacao): void{
    if(button.action === 'remover')   this.removerParticipante(participante);
    if(button.action === 'reciclar')  this.goTo('reciclar', participante);
    if(button.action === 'historico') this.goTo('historico', participante);
  }

  goTo(local:string, participante:any | Participacao): void{
    switch(local){
      case 'contratos':
        this.navCtrl.push(ContratoSearchPage, {});
        break;
      case 'historico':
        this.navCtrl.push(ReciclagemHistoricoPage, {'id':participante.id});
        break;
      case 'reciclar':
        this.navCtrl.push(ReciclagemPage, {'id':participante.id});
        break;
    }

  }

  adicionarParticipante(contrato:any){
    let load  = this.loading.create({content: 'Adicionando participante...'});
    let toast = this.toastCtrl.create({ duration: 2000 });
    let self  = this;
    load.present();


    if(this.evento_aberto === undefined){
      let toast = this.toastCtrl.create({ duration: 1500 });
      toast.setMessage('Selecione um evento antes de continuar!');
      toast.present();
      return false;
    }

    let participacao:any = {cliente_id:  contrato.cliente.id,
                            evento_id:   this.evento_aberto.id,
                            contrato_id: contrato.id,
                            modulo_id:  4 ,
                            status: 'A'};



    this.participacaoProvider.adicionarParticipante(participacao).then(function(result:any){
      load.dismiss();
      self.navCtrl.push(ReciclagemPage, {
        'id':result.id
      })
    }).catch(function(reject){
      load.dismiss();
      toast.setMessage(reject.msg);
      toast.present();
      self.navCtrl.push(ReciclagemPage, {
        'id':reject.participacao.id
      })

    });

  }

  removerParticipante(participante:any){
    let alert = this.alertCtrl.create({
      title: 'CONFIRMAR REMOÇÃO',
      message: 'Remover '+this.anonymizeProvider.anonymizeName(participante.cliente.nome)+' <br /> do evento <br />'+this.evento_aberto.acao.nome+' - '+this.evento_aberto.local.nome,
      buttons: [
        {
          text: 'VOLTAR',
          role: 'cancel',
          handler: () => { }
        },
        {
          text: 'REMOVER',
          handler: () => {
            let load  = this.loading.create({content: 'Removendo participante...'});
            let toast = this.toastCtrl.create({ duration: 2000 });
            let self  = this;
            load.present();

            this.participacaoProvider.removerParticipante(participante).then(function(result:any){
              load.dismiss();
              toast.setMessage('Partipante removido!');
              toast.present();

              self.navCtrl.setRoot(ParticipacaoPage);
            }).catch(function(reject){
              if(reject.status === 500){
                load.dismiss();
                toast.setMessage(reject.msg);
                toast.present();
              }
            });

          }
        }
      ]
    });
    alert.present();
  }

  /* Privates  */
  private getEventoAberto():any{
    if(localStorage.getItem('evento_aberto')){
      this.evento_aberto = JSON.parse(localStorage.getItem('evento_aberto'));
      return true;
    }else{
      let toast = this.toastCtrl.create({ duration: 1500 });
      let self = this;
      toast.setMessage('Selecione um evento antes de continuar!');
      toast.present();
      toast.onDidDismiss(() => {
        self.navCtrl.setRoot('HomePage');
      });
      return false;
    }
  }

  /**
   * Verifica se pode adicionar participantes (compatível com TS antigo)
   */
  canAddParticipants(): boolean {
    return this.permissionService.hasNavigationPermission('participacao', 'cadastrar');
  }

  /**
   * Verifica se pode remover participantes (compatível com TS antigo)
   */
  canRemoveParticipants(): boolean {
    return this.permissionService.hasNavigationPermission('participacao', 'remover');
  }

  /**
   * Verifica se é OPERADOR RECICLAGEM (compatível com TS antigo)
   */
  isOperadorReciclagem(): boolean {
    return this.permissionService.isCurrentUserOperadorReciclagem();
  }

  /**
   * Obtém nome do perfil atual (compatível com TS antigo)
   */
  getCurrentProfileName(): string {
    return this.permissionService.getCurrentUserProfileName();
  }


}



// WEBPACK FOOTER //
// ./src/pages/participacao/participacao.ts